"use client";

import { useAssignSettingFEEnableLISPNextPagePrefetchingBugFix } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingFEEnableLISPNextPagePrefetchingBugFix";
import { useSyncRecentSearchesToPageVisit } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageEffects/__internal__/useSyncRecentSearchesToPageVisit";
import { useSearchPageLogLastQueryEffect } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageEffects/SearchPageLogLastQueryEffect";
import { useSearchPageMaybeAssignCategoryTreeExperiment } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageMaybeAssignCategoryTreeExperiment/SearchPageMaybeAssignCategoryTreeExperiment";
import { useSearchPageAnalyticsTracking } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageAnalyticsTracking/useSearchPageAnalyticsTracking";
import { useSearchPageViewStateLifeCycle } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/useSearchPageViewStateLifeCycle";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import React, { useEffect } from "react";

/**
 * For future new effects, please add them into this component, instead of
 * the Search Page component. This is to optimise performance and avoid unnecessary
 * re-renders for the main page component that don't depend on these effects.
 */
export const SearchPageEffects = () => {
  useTraceComponentRender("SearchPageEffects");

  return (
    <>
      <Effects />
    </>
  );
};

const Effects = () => {
  useSyncRecentSearchesToPageVisit();
  useSearchPageAnalyticsTracking();
  useSearchPageMaybeAssignCategoryTreeExperiment();
  useSearchPageLogLastQueryEffect();
  useSearchPageViewStateLifeCycle();
  useSearchPageAssignSettingFEEnableLISPNextPagePrefetchingBugFix();

  return null;
};

const useSearchPageAssignSettingFEEnableLISPNextPagePrefetchingBugFix = () => {
  const assignSettingFEEnableLISPNextPagePrefetchingBugFix =
    useAssignSettingFEEnableLISPNextPagePrefetchingBugFix();

  useEffect(() => {
    assignSettingFEEnableLISPNextPagePrefetchingBugFix();
  }, []);

  return null;
};
